import { ColorFormComponent } from './color-form/color-form.component';
import { SizeFormComponent } from './size-form/size-form.component';
import { SizeListComponent } from './size-list/size-list.component';
import { CategoryFormComponent } from './category-form/category-form.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CategoryListComponent } from './category-list/category-list.component';
import { SubcategoryFormComponent } from './subcategory-form/subcategory-form.component';
import { SubcategoryListComponent } from './subcategory-list/subcategory-list.component';
import { ColorListComponent } from './color-list/color-list.component';

const routes:Routes=[
    {path:'', redirectTo:'category',pathMatch:'full'},
    {path:'category',children:[
        {path:'',redirectTo:'list', pathMatch:'full'},
        {path:'list', component:CategoryListComponent},
        {path:'new', component:CategoryFormComponent},
        {path:'edit', component:CategoryFormComponent},
    ]},
    {path:'subcategory',children:[
        {path:'',redirectTo:'list', pathMatch:'full'},
        {path:'list', component:SubcategoryListComponent},
        {path:'new', component:SubcategoryFormComponent},
        {path:'edit', component:SubcategoryFormComponent},
    ]},
    {path:'size',children:[
        {path:'',redirectTo:'list', pathMatch:'full'},
        {path:'list', component:SizeListComponent},
        {path:'new', component:SizeFormComponent},
        {path:'edit', component:SizeFormComponent},
    ]},
    {path:'color',children:[
        {path:'',redirectTo:'list', pathMatch:'full'},
        {path:'list', component:ColorListComponent},
        {path:'new', component:ColorFormComponent},
        {path:'edit', component:ColorFormComponent},
    ]},
]
@NgModule({
    imports: [
      RouterModule.forChild(routes)
    ],
    exports:[
      RouterModule
    ]
  })
  export class SettingsRoutingModule { }
  